import Vue from 'vue';
import Router from 'vue-router';
import vueHome from '@/views/vueHome.vue'; // 引入 hotProducts 页面
import hotProducts from '@/views/hotProducts.vue'; // 引入 hotProducts 页面
import vuenews from '@/views/news.vue'; // 引入 hotProducts 页面
import vueabout from '@/views/about.vue'; // 引入 hotProducts 页面
import vuecompanyt from '@/views/company.vue'; // 引入 hotProducts 页面
import vuedetail from '@/views/detail.vue'; // 引入 hotProducts 页面

Vue.use(Router);

export default new Router({
  mode: 'history', // 使用 history 模式
  routes: [
    {
      path: '/',
      name: 'vueHome',
      component: vueHome, // 配置 hotProducts 路由
    },
    {
      path: '/hotProducts',
      name: 'hotProducts',
      component: hotProducts, // 配置 hotProducts 路由
    },
    {
      path: '/news',
      name: 'news',
      component: vuenews, // 配置 hotProducts 路由
    },
    {
      path: '/about',
      name: 'about',
      component: vueabout, // 配置 hotProducts 路由
    },
    {
      path: '/company',
      name: 'company',
      component: vuecompanyt, // 配置 hotProducts 路由
    },
    {
      path: '/detail/:id',
      name: 'detail',
      component: vuedetail, // 配置 hotProducts 路由
    },
    
    // 其他路由
  ],
});